import { useQuery } from "@apollo/client";
import { OrganizationSharingsDocument } from "../../__generated__/graphql";
import { useUser } from "../../contexts/UserContext/hooks/useUser";

interface UseOrganizationSharingsOptions {
  skip?: boolean;
}

export default function useOrganizationSharings(
  options?: UseOrganizationSharingsOptions
) {
  const { currentOrganization } = useUser();
  const { data, loading, error, refetch } = useQuery(
    OrganizationSharingsDocument,
    { skip: options?.skip }
  );

  const externalUserOrganizations = data?.organizationSharings
    .flatMap(
      (organizationSharing) =>
        organizationSharing?.assignedPublicUserOrganizations
    )
    .filter(
      (userOrganization) =>
        userOrganization?.organizationId !== currentOrganization?.id
    )
    .filter((userOrganization) => userOrganization !== null);

  return {
    data,
    loading,
    error,
    externalUserOrganizations,
    refetch,
  };
}
